import { getCollectionDescription } from '../../apis/metaData';
import { collectionMetaTagString } from '../../utilities/meta_tags_util';
import { checkImgType } from '../../utilities/image_util';
import { getLanguageByRank } from '../../utilities/language';

const getSecretId = () => process.env.SECRET_ID_FOR_META_TAGS;
const NO_CONTENT = '204';

async function loadData(urlPath, language, query, params, headers) {
  if (!params) {
    return {
      notFound: true,
    };
  }

  const { userid, folderid } = params;
  if (!userid || !folderid) {
    return {
      notFound: true,
    };
  }
  const secretId = getSecretId();

  try {
    const response = await getCollectionDescription(userid, folderid, secretId);
    const { data } = response;

    if (data.status === NO_CONTENT) {
      return {
        notFound: true,
      };
    }

    const {
      results: {
        title,
        description,
        nickname,
        cover,
        noindex,
        language: authorLanguage,
      },
    } = data;
    const metaLanguage = getLanguageByRank(
      query.hl,
      authorLanguage,
      headers['accept-language'],
    );
    const htmlLang = authorLanguage || 'en';
    const image = checkImgType({ data: cover, isSSR: true });
    const metaData = collectionMetaTagString({
      urlPath,
      title,
      description,
      nickname,
      image,
      noindex,
      language: metaLanguage,
    });
    return {
      metaData,
      htmlLang,
    };
  } catch (error) {
    console.log(error);
    return {
      metaData: null,
    };
  }
}

export default loadData;
